import { useEffect, useState } from "react";
import { itx } from "../translationItx/itx";

export default function BridgeStatus(props: { showDescription?: boolean; autoConnect?: boolean }) {
  const { showDescription, autoConnect } = props;
  const [bridgeOpenError, setBridgeOpenError] = useState(false);
  const [bridgeOpenTimeout, setBridgeOpenTimeout] = useState(false);
  const [downloadStarted, setDownloadStarted] = useState(false);

  useEffect(() => {
    if (autoConnect) {
      openEstada();
    }
  }, [autoConnect]);

  useEffect(() => {
    if (bridgeOpenError) {
      setTimeout(() => {
        setBridgeOpenTimeout(true);
      }, 15000);
    }
  }, [bridgeOpenError]);

  const openEstada = () => {
    // e.preventDefault(); // e: React.MouseEvent<HTMLAnchorElement>

    setBridgeOpenError(false);
    setDownloadStarted(false);

    // Attempt to open protocol handler (always)
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = "estada://bridgegateway";
    document.body.appendChild(iframe);

    // Clean up iframe
    setTimeout(() => {
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
    }, 2000);

    // After 1.5s always switch to download text
    setTimeout(() => {
      setBridgeOpenError(true);
    }, 1500);
  };

  // Older logic:
  //   const openEstada = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   e.preventDefault(); // prevent browser navigation
  //   setBridgeOpenError(false);

  //   const start = Date.now();

  //   // Attempt to open protocol handler
  //   const iframe = document.createElement("iframe");
  //   iframe.style.display = "none";
  //   iframe.src = "estada://bridgegateway";
  //   document.body.appendChild(iframe);

  //   // Clean up iframe later
  //   setTimeout(() => document.body.removeChild(iframe), 2000);

  //   // If after 1500ms user hasn't switched context -> assume fail
  //   const timeout = setTimeout(() => {
  //     const now = Date.now();
  //     if (now - start >= 1400) {
  //       setBridgeOpenError(true);
  //     }
  //   }, 1500);

  //   // If app opened (blur event), cancel failure state
  //   const onBlur = () => {
  //     clearTimeout(timeout);
  //     window.removeEventListener("blur", onBlur);
  //   };

  //   window.addEventListener("blur", onBlur, { once: true });
  // };

  return (
    <span>
      {!bridgeOpenError && (
        <span style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap" }}>
          {showDescription && <span>{itx("knxBridge.disconnectedFromNw", "Not connected to gateway.")}</span>}
          <button className="button" style={{ margin: "0px" }} onClick={() => openEstada()}>
            {itx("knxBridge.startEstadaGateWay", "Start Estada Gateway")}
          </button>
        </span>
      )}

      {bridgeOpenError && (
        <span>
          {!downloadStarted ? (
            <span>
              {!bridgeOpenTimeout &&
                itx("knxBridge.startingText1", "Starting gateway — if it's not installed already, you can")}
              {bridgeOpenTimeout &&
                itx(
                  "knxBridge.startingText1Alt",
                  "Unable to start the gateway. Please make sure its installed, or",
                )}{" "}
              <a
                href="https://download.estada.de/EstadaGatewaySetup.msi" // no itx
                onClick={() => setDownloadStarted(true)}
              >
                {itx("knxBridge.startingText2", "download it here.")}
              </a>{" "}
            </span>
          ) : (
            <span>
              {itx("knxBridge.beingInstalledText1", "The installer is being downloaded. Please open")}{" "}
              <strong>EstadaGatewaySetup.msi</strong>{" "}
              {itx("knxBridge.beingInstalledText2", "from your downloads folder to complete the installation.")}
            </span>
          )}
        </span>
      )}
    </span>
  );
}
